import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { BackButton, Title } from '~ComponentsImproved/BackTopBar';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import BackIcon from '~Assets/icons/arrow_back.svg';
import ErrorCircleIcon from '~Assets/icons/error-circle.svg';

import { useButton, useI18n } from '~Hooks';
import { useHistory } from 'react-router';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';

const Wrapper = styled(Box)`
  height: 100vh;
  position: relative;
`;

const TopBar = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
`;

const NoData: FC = () => {
  const { i18n } = useI18n();
  const history = useHistory();

  const handleBack = () => {
    history.push('/venues');
  };

  const backButton = useButton({
    onClick: handleBack,
  });

  return (
    <Wrapper display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <TopBar display="flex" alignItems="center" padding="medium">
        <BackButton {...backButton}>
          <Icon src={BackIcon} color="var(--colorBlueGray1200)" />
        </BackButton>
        <Title dark={false}>{i18n('SSK.Return')}</Title>
      </TopBar>

      <Icon height="120px" width="120px" src={ErrorCircleIcon} color="var(--colorUIRed)" />

      <Heading level={1} color="var(--colorBlueGray1200)" top={16}>
        {i18n('SSK.NoData')}
      </Heading>
      <Paragraph level={2} color="var(--colorBlueGray1200)" top={8}>
        {i18n('SSK.NoData.Desc')}
      </Paragraph>
    </Wrapper>
  );
};

export default NoData;
